/**
 * Power Kitchen LP — Quiz section
 * Multi-step client-side quiz with meal plan recommendation.
 * quiz_mode (data-lp-quiz-mode): "female", "male", or "all"
 *   female → Lean Muscle / Pro Athlete / GLP1
 *   male   → Power / Pro Athlete / GLP1
 *   all    → all four + gender step
 */
document.addEventListener('DOMContentLoaded', function () {
  var PLANS = {
    lean_muscle: {
      slug: 'lean-muscle',
      name: 'Lean Muscle',
      description: 'A balanced plan built around your training: high protein, smart carbs, and the right fuel to build lean muscle without the guesswork.'
    },
    power: {
      slug: 'power',
      name: 'Power',
      description: 'Designed for strength and performance: higher calories, bigger portions, and macros tuned to support heavy training and recovery.'
    },
    pro_athlete: {
      slug: 'pro-athlete',
      name: 'Pro Athlete',
      description: 'For serious athletes training at high volume, with precision nutrition matched to your sport, schedule, and performance goals.'
    },
    glp1: {
      slug: 'glp-1',
      name: 'GLP1',
      description: 'Optimized for nutrition-driven results: high-protein, portion-controlled meals designed to support your weight management journey.'
    }
  };

  // What the six-week programme actually sells: one bundle family per
  // (gender, goal), plus GLP-1. The quiz recommends one of these, and
  // /pages/six-weeks-program?program=<key> opens with it selected.
  var PROGRAMS = {
    'female-muscle-gain': {
      name: 'Female Muscle Gain',
      description: 'High-protein meals with the right fuel to build lean muscle around your training, planned for six weeks.'
    },
    'female-weight-loss': {
      name: 'Female Weight Loss',
      description: 'Portion-controlled, high-protein meals that keep you full while you lose fat, planned for six weeks.'
    },
    'male-muscle-gain': {
      name: 'Male Muscle Gain',
      description: 'Bigger portions and higher protein to support strength training and recovery, planned for six weeks.'
    },
    'male-weight-loss': {
      name: 'Male Weight Loss',
      description: 'Protein-forward meals in a calorie range built for fat loss without losing strength, planned for six weeks.'
    },
    glp1: {
      name: 'GLP-1',
      description: 'High-protein, high-fiber meals designed to support your medication and curb hunger, planned for six weeks.'
    }
  };

  function calculateProgram(state, mode) {
    if (calculatePlan(state, mode) === 'glp1') return 'glp1';
    var gender = mode === 'all' ? (state.gender || 'female') : mode;
    var goal = state.goal === 'Lose fat' ? 'weight-loss' : 'muscle-gain';
    return (gender === 'male' ? 'male' : 'female') + '-' + goal;
  }

  var HIGH_FREQ = ['4-5x/week', '6+x/week'];
  var LOW_FREQ = ['Less than 2x/week', "I'm not training right now"];
  var PERFORMANCE_GOALS = ['Build strength', 'Training for something specific'];

  function calculatePlan(state, mode) {
    var goal = state.goal || '';
    var frequency = state.frequency || '';
    var gender = mode === 'all' ? (state.gender || 'female') : mode;

    if (HIGH_FREQ.indexOf(frequency) !== -1 && PERFORMANCE_GOALS.indexOf(goal) !== -1) {
      return 'pro_athlete';
    }

    if (goal === 'Lose fat' && LOW_FREQ.indexOf(frequency) !== -1) {
      return 'glp1';
    }

    return gender === 'male' ? 'power' : 'lean_muscle';
  }

  var quizEls = document.querySelectorAll('[data-lp-quiz]');
  if (!quizEls.length) return;

  function showStep(quizEl, stepEls, progressFillEl, progressLabelEl, progressWrapperEl, stepKey, totalSteps) {
    stepEls.forEach(function (stepEl) {
      var isActive = stepEl.dataset.lpQuizStep === stepKey;
      stepEl.classList.toggle('lp-pk-quiz__step--active', isActive);
      stepEl.hidden = !isActive;
    });

    var stepNumber = parseInt(stepKey, 10);
    var isQuestionStep = !isNaN(stepNumber);

    if (progressWrapperEl) {
      progressWrapperEl.hidden = !isQuestionStep;
    }

    if (isQuestionStep && progressFillEl && progressLabelEl) {
      progressFillEl.style.width = (stepNumber / totalSteps) * 100 + '%';
      progressLabelEl.textContent = stepNumber + '/' + totalSteps;
    }
  }

  function selectOption(state, optionEl) {
    var optionsWrapperEl = optionEl.closest('[data-lp-quiz-options]');
    if (!optionsWrapperEl) return;

    var field = optionsWrapperEl.dataset.lpQuizField;

    optionsWrapperEl.querySelectorAll('[data-lp-quiz-option]').forEach(function (btn) {
      btn.classList.remove('lp-pk-quiz__option--selected');
      btn.setAttribute('aria-pressed', 'false');
    });

    optionEl.classList.add('lp-pk-quiz__option--selected');
    optionEl.setAttribute('aria-pressed', 'true');

    if (field) {
      state[field] = optionEl.dataset.value || '';
    }
  }

  function populateResults(quizEl, state, mode) {
    quizEl.querySelectorAll('[data-lp-quiz-result]').forEach(function (resultEl) {
      var field = resultEl.dataset.lpQuizResult;
      resultEl.textContent = state[field] || '';
    });

    var programKey = calculateProgram(state, mode);
    var plan = PROGRAMS[programKey];
    var recEl = quizEl.querySelector('[data-lp-quiz-recommendation]');
    var nameEl = quizEl.querySelector('[data-lp-quiz-plan-name]');
    var descEl = quizEl.querySelector('[data-lp-quiz-plan-description]');

    if (recEl && nameEl && descEl && plan) {
      nameEl.textContent = plan.name;
      descEl.textContent = plan.description;
      recEl.hidden = false;
    }

    // Remembered for the redirect after the Klaviyo form is sent.
    if (plan) {
      quizEl.dataset.lpQuizProgram = programKey;
      pointCtasAt(programKey);
    }
  }

  // Once the quiz has recommended a programme, every CTA of the page that goes
  // to the programme page opens it with that programme instead of the page's
  // default one.
  function pointCtasAt(programKey) {
    document.querySelectorAll('.lp-pk-cta__button[href*="six-weeks-program"]').forEach(function (link) {
      try {
        var url = new URL(link.getAttribute('href'), window.location.origin);
        if (url.origin !== window.location.origin) return;
        url.searchParams.delete('plan');
        url.searchParams.set('program', programKey);
        link.setAttribute('href', url.pathname + url.search + url.hash);
      } catch (error) {
        // A malformed link stays as the editor saved it.
      }
    });
  }

  // After the customer sends the Klaviyo form in the results step, take them
  // to the section's "result_url" with the recommended programme
  // (?program=female-muscle-gain), which opens the purchase screen on it. The form itself only submits and
  // closes (configured in Klaviyo), so this is the one redirect. No URL in
  // the section = stay on the page, as before.
  var REDIRECT_DELAY_MS = 800;

  function klaviyoFormIdOf(quizEl) {
    var formEl = quizEl.querySelector('[class*="klaviyo-form-"]');
    if (!formEl) return null;
    var match = formEl.className.match(/klaviyo-form-([A-Za-z0-9]+)/);
    return match ? match[1] : null;
  }

  function resultUrlFor(quizEl) {
    var base = quizEl.dataset.lpQuizResultUrl;
    var programKey = quizEl.dataset.lpQuizProgram;
    if (!base) return null;
    try {
      var url = new URL(base, window.location.origin);
      if (url.origin !== window.location.origin) return null;
      url.searchParams.delete('plan');
      if (programKey) url.searchParams.set('program', programKey);
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return null;
    }
  }

  window.addEventListener('klaviyoForms', function (event) {
    var detail = event && event.detail;
    if (!detail || detail.type !== 'submit') return;

    quizEls.forEach(function (quizEl) {
      if (klaviyoFormIdOf(quizEl) !== detail.formId) return;
      var target = resultUrlFor(quizEl);
      if (!target) return;
      // A short pause so Klaviyo finishes its own request before the page
      // goes away.
      setTimeout(function () {
        window.location.assign(target);
      }, REDIRECT_DELAY_MS);
    });
  });

  function initQuiz(quizEl) {
    var state = {};
    var mode = quizEl.dataset.lpQuizMode || 'all';
    var totalSteps = parseInt(quizEl.dataset.lpQuizTotalSteps, 10) || 4;
    var stepEls = quizEl.querySelectorAll('[data-lp-quiz-step]');
    var progressFillEl = quizEl.querySelector('[data-lp-quiz-progress-fill]');
    var progressLabelEl = quizEl.querySelector('[data-lp-quiz-progress-label]');
    var progressWrapperEl = quizEl.querySelector('[data-lp-quiz-progress]');
    var postalInputEl = quizEl.querySelector('[data-lp-quiz-postal]');
    var optionEls = quizEl.querySelectorAll('[data-lp-quiz-option]');

    optionEls.forEach(function (optionEl) {
      optionEl.addEventListener('click', function () {
        var stepEl = optionEl.closest('[data-lp-quiz-step]');
        if (!stepEl) return;

        var currentStep = parseInt(stepEl.dataset.lpQuizStep, 10);
        var isPostalStep = currentStep === 4;

        if (isPostalStep && postalInputEl && postalInputEl.value.trim() === '') {
          postalInputEl.classList.add('lp-pk-quiz__input--error');
          postalInputEl.focus();
          return;
        }

        if (postalInputEl) {
          postalInputEl.classList.remove('lp-pk-quiz__input--error');
        }

        selectOption(state, optionEl);

        var nextStepKey = currentStep < totalSteps ? String(currentStep + 1) : 'results';

        if (nextStepKey === 'results') {
          populateResults(quizEl, state, mode);
        }

        showStep(quizEl, stepEls, progressFillEl, progressLabelEl, progressWrapperEl, nextStepKey, totalSteps);
      });
    });

    showStep(quizEl, stepEls, progressFillEl, progressLabelEl, progressWrapperEl, '1', totalSteps);
  }

  try {
    quizEls.forEach(initQuiz);
  } catch (error) {
    console.error('lp-power-kitchen-quiz: init failed', error);
  }
});
